import { NgxSpinnerService } from 'ngx-spinner';
import { PreloaderService } from './../_services/Preloader.service';
import { browser } from 'protractor';
import { Logs } from './../_models/Logs';
import { LogService } from './../_services/_LogServices/Log.service';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { User } from './../_models/User';
import { _userServicesService } from './../_services/_UserService/_userServices.service';


import { Component, OnInit } from '@angular/core';
import { Device } from '../_models/Device';
import { ToasterService } from './../_services/Toaster.service';
import { DeviceService } from '../_services/_DeviceService/Device.service';

@Component({
  selector: 'app-Log_Manage',
  templateUrl: './Log_Manage.component.html',
  styleUrls: ['./Log_Manage.component.css']
})
export class Log_ManageComponent implements OnInit {

  public Device: Device[];
  public FromDate: any;
  public ToDate: any;
  public selectedDevice: any;
  public Logs:Logs[];
  public DatatableToggle=false;
  dtOptions: any = {};

  constructor(private Spiner:NgxSpinnerService, private preloader:PreloaderService, private DeviceService: DeviceService,private Logservice:LogService, private UserService: _userServicesService, private noti: ToasterService) { }


  ngOnInit() {
    this.LoadAllDevices();

    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      dom: 'Bfrtip',
        buttons: [
            'copy', 'csv', 'excel', 'pdf', 'print'
        ]
      }
  }

  selectChangeHandler(event: any) {
    this.selectedDevice = event.target.value;
    // this.LoadAllUser(this.selectedDevice);
  }
  LoadAllDevices() {
    // tslint:disable-next-line: no-shadowed-variable
    try {
      this.DeviceService.GetActiveDeviceList().subscribe(
        Response => {
          this.preloader.hide();
          if (Response.status == 200) {
            this.Device = Response.body;


          }
          else {
            this.noti.error("Error", Response.body);
          }

        },
        err => {
          this.preloader.hide();
          this.noti.error("Error", err.error);
        }
      );
    } catch (error) {
      this.preloader.hide();
      this.noti.error("Error", "Code Crashed");
    }
  }

  GetAllLogs(DeviceID, FromDate, ToDate) {
   DeviceID="asd";
    this.Spiner.show();
    if (DeviceID == "")
    {
      this.Spiner.hide();
      return  this.noti.error("Select Device Required", "Error");
    }
    if (DeviceID == "Select Device")
    {
      this.Spiner.hide();
      return  this.noti.error("Select Device Required", "Error");
    }
    try {
      this.DatatableToggle=false;
      this.Logservice.GetAllLogs(this.selectedDevice,FromDate,ToDate).subscribe((Response: any) => {
        this.Spiner.hide();
         if (Response.status == 200) {

            this.Logs=Response.body;
            this.Logs.forEach(element => {
              var date = new Date(element.time);

              element.time = date.getDate().toString() + '-' + (date.getMonth()+1).toString() + '-' + date.getFullYear() + '  ' + date.getHours() + ':' + date.getMinutes() + ':00'
            });
           if(this.Logs.length==0)
           {
            this.DatatableToggle=true;
           return this.noti.error("Message", "No Data Found");
           }
           this.DatatableToggle=true;
         }
         else {

           this.noti.error("Message", "Get Logs Data");
         }

      });

   } catch (error) {
    this.noti.error("Message", "Get Logs Data");
    this.Spiner.hide();
   }




  }
}
